// components/shop/ShopSidebar.tsx
import React from 'react';
import {
  LayoutDashboard,
  FileText,
  Package,
  Settings,
  Star,
  Store
} from 'lucide-react';
import Sidebar, { SidebarConfig } from '../../shared/DashboardSidebar';
import { Shop } from '@cabukaka/types';

interface ShopSidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
  username: string;
  logoUrl?: string;
  isMobile?: boolean;
  shopData: Shop;
}

const ShopSidebar: React.FC<ShopSidebarProps> = ({
  isCollapsed,
  onToggle,
  username,
  logoUrl,
  isMobile = false,
  shopData
}) => {
  // Vérification si les informations de la boutique sont complètes
  const isShopInfoComplete = shopData?.name && shopData?.name.trim() !== '';

  // Construction de la configuration
  const config: SidebarConfig = {
    username,
    logoUrl,
    onActivateModules: () => {
      // Navigation vers les paramètres
      window.location.href = '/shop/parametres';
    },
    sections: [
      {
        title: 'Général',
        items: [
          { 
            icon: LayoutDashboard, 
            label: 'Tableau de bord', 
            path: '/shop/overview' 
          },
          { 
            icon: Settings, 
            label: 'Paramètres', 
            path: '/shop/settings' 
          },
          {
            icon: Store,
            label: isShopInfoComplete ? 'Ma boutique': 'Créer une boutique',
            // Si les infos sont incomplètes, rediriger vers paramètres, sinon vers la page boutique
            path: isShopInfoComplete ? `/shop/details?id=${shopData.id}` : '/shop/create'
          }
        ]
      },
      {
        title: 'Modules',
        items: [
          {
            icon: Package,
            label: 'Produits',
            path: '/shop/products',
          },
          {
            icon: FileText,
            label: 'Commandes',
            path: '/shop/orders',
          },
          {
            icon: Star,
            label: 'Avis des clients',
            path: '/shop/reviews',
          },
        ]
      }
    ]
  };

  return (
    <Sidebar
      config={config}
      isCollapsed={isCollapsed}
      onToggle={onToggle}
      isMobile={isMobile}
    />
  );
};

export default ShopSidebar;